import { render, staticRenderFns } from "./DocKeywordsSettingsDialog.vue?vue&type=template&id=003608d3"
import script from "./DocKeywordsSettingsDialog.vue?vue&type=script&lang=js"
export * from "./DocKeywordsSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./DocKeywordsSettingsDialog.vue?vue&type=style&index=0&id=003608d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports